// @ts-strict-ignore
import { OrderLineFragment } from "@dashboard/graphql";
import React from "react";

import { OrderDetailsGroupedTable } from "./OrderDetailsGroupedTable";

interface OrderDetailsDatagridProps {
  lines: OrderLineFragment[];
  loading: boolean;
  orderId?: string;
  onShowMetadata?: (id: string) => void;
}

export const OrderDetailsDatagrid = ({
  lines,
  loading,
  orderId,
  onShowMetadata,
}: OrderDetailsDatagridProps) => {
  return (
    <OrderDetailsGroupedTable
      lines={lines}
      loading={loading}
      orderId={orderId}
      onShowMetadata={onShowMetadata}
    />
  );
};
